import React, { useEffect, useState } from "react";
import Header from "../../../SharedFiles/Header/Header";
import Footer from "../../../SharedFiles/Footer/Footer";
import { useDispatch, useSelector } from "react-redux";
import { toast, Toaster } from "react-hot-toast";
import { BiArrowBack } from "react-icons/bi";
import QRCodeGenerator from "../../../SharedFiles/QRCode/qrGenerator";
import { useNavigate } from "react-router-dom";
import {
  GetItemTemp,
  GetWhsTotalQtybyitem,
  PostInvPosting,
} from "../../../APIServices/ProductionService/InventoryPosting/inventoryPostingThunk";
import "./inventoryPosting.css";
import { HashLoader } from "react-spinners";
import InvPostingInput from "./InvPostingInput";
import {
  showNavigateConfirmation,
  showSubmitConfirmation,
} from "../../../SharedFiles/WarningMessage/deleteWarning";
import { generateQRData, parseFormattedQRText, validateFormData } from "../../../SharedFiles/Helper/utils";
import { useTranslation } from "react-i18next";
import { useQRModal } from "../../../../Context/QrContext";

const InvPostingMain = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { t } = useTranslation();
  const [openManual, setOpenManual] = useState(false);
  const [openModel, setOpenModel] = useState(true);
  const [QrTrigger, setQrTrigger] = useState(false);
  const [selectedBatch, setSelectedBatch] = useState("");
  const [errorMessage, setErrorMessage] = useState({});
  const [dropdownVisible, setDropdownVisible] = useState(false);
  const [postQr, setPostQr] = useState({});
  const { GetDetailsItem, GetWhsQty, postResponse, loading, error } =
    useSelector((state) => state.InvPosting || {});
  const { setQRmodalOpen, setQrData, QRdata, PrintLabel, setPrintStatus } =
    useQRModal();

  const isLoading = () => {
    return loading.GetDetailsItem || loading.GetWhsQty || loading.postResponse;
  };
  const [InProgress, setInProgress] = useState({
    InventoryPost: false,
    GetBatch: false,
    WarehouseQty: false,
  });

  const [formData, setFormData] = useState({
    batch_Number: "",
    item_Code: "",
    net_Weight: "",
    Actual_Weight: "",
    Difference: "",
    Remarks: "",
    absEntry: "",
    pur_Number: "",
  });
  useEffect(() => {
    if (!InProgress.GetBatch && (!GetDetailsItem || GetDetailsItem.length === 0)) {
        setInProgress({ ...InProgress, GetBatch: true });
      dispatch(GetItemTemp());
    }
  }, [GetDetailsItem, dispatch]);

  useEffect(() => {
    if (InProgress.InventoryPost && postResponse === "Success") {
      toast.success(t("Submitted successfully"));
      setFormData({
        batch_Number: "",
        item_Code: "",
        net_wt: "",
        Actual_Weight: "",
        Difference: "",
        Remarks: "",
      });
      setQRmodalOpen(false);
      setQrData({});
      setPostQr({});
      dispatch(GetItemTemp());
    }
    if (InProgress.InventoryPost && error.postResponseError) {
      setInProgress((prev) => ({
        ...prev,
        InventoryPost: false, // Reset loading state in case of error
      }));
      const errors = error.postResponseError;
      const status = errors.status;
      const errormessage = errors.errorMessage;
      if (status === 400) {
        toast.error("BadRequest");
      } else toast.error(errormessage);
    }
  }, [postResponse, error]);

  // useEffect(() => {
  //     if (QrTrigger) {
  //         const filtered = GetDetailsItem.filter(item =>
  //             item.batch_Number.toLowerCase().includes(selectedBatch.Batch_Number && selectedBatch.Batch_Number.toLowerCase())
  //         );
  //         if (filtered.length === 0) {
  //             toast.error(t('Batch Number not found!'));
  //         } else {
  //             const item =filtered[0];
  //             const header ="batch_Number"
  //             handleSelectSuggestion(item,header);
  //             setOpenManual(true);
  //         }
  //           setQrTrigger(false);
  //     }
  // }, [QrTrigger]);

  const batchChecker = () => {
    if (InProgress.GetBatch && error.GetDetailsItemError) {
      const errorss = error.GetDetailsItemError;
      const status = errorss.errorCode;
      const errormessage = errorss;
      setInProgress({ ...InProgress, GetBatch: false });
      toast.error(errormessage);
      setOpenModel(false);
      return;
    }
    if (InProgress.WarehouseQty && error.GetWhsQtyError) {
      const errorss = error.GetWhsQtyError;
      const status = errorss.errorCode;
      const errormessage = errorss;
      setInProgress({ ...InProgress, GetBatch: false });
      toast.error(errormessage);
      return;
    }
  };
  useEffect(() => {
    batchChecker(); // Call batchChecker every time DisassembleBatch or error changes
  }, [GetDetailsItem, GetWhsQty, loading, error, InProgress]);

  const inputfieldLabel =
    GetDetailsItem && GetDetailsItem.length > 0
      ? [
          ...Object.keys(GetDetailsItem[0]),
          "Actual_Weight",
          "Difference",
          "Remarks",
        ].filter((field) => field !== "absEntry" && field !== "pur_Number") // Filter out unwanted fields
      : [];
  const handleSelectSuggestion = (item, header) => {
    setFormData({});
    setPrintStatus(false);
    setErrorMessage({});
    const data = item;
    setFormData((prevData) => ({
      ...prevData,
      [header]: data[header],
    }));
    if (header === "item_Code") {
      setFormData((prevData) => ({
        ...prevData,
        item_Name: data.item_Name,
      }));
    }
    if (header === "item_Name") {
      setFormData((prevData) => ({
        ...prevData,
        item_Code: data.item_Code,
        item_Name: data.item_Name,
      }));
    }
    if (header === "batch_Number") {
      setFormData((prevData) => ({
        ...prevData,
        ...data,
      }));
    }
    
    setErrorMessage((prevErrors) => ({
      ...prevErrors,
      [header]: "", // Reset the error for the current header
    }));
    const WhsCode = "RM";
    if(!InProgress.WarehouseQty) {
        
    setInProgress({ ...InProgress, WarehouseQty: true });
    dispatch(GetWhsTotalQtybyitem({ itemCode: data.item_Code, WhsCode }));
    }
    setDropdownVisible(false); // Hide dropdown after selection
  };

  const onPrint = () => {
    const {
      item_Code,
      batch_Number,
      Difference,
      Actual_Weight,
      net_Weight,
      pur_Number,
    } = formData;
    if (!item_Code || !batch_Number || !Difference || !Actual_Weight) {
      toast.error(t("Please fill in the required fields"));
      return;
    }
    // const validationFields =['item_Code','batch_Number'];
    const validationRules = [
      { field: "item_Code", validationTypes: ["exists", "required"] },
      { field: "batch_Number", validationTypes: ["required"] },
    ];
    const newErrorMessage = validateFormData(
      validationRules,
      GetDetailsItem,
      formData
    );

    // If validation fails, return early
    if (Object.keys(newErrorMessage).length > 0) {
      setErrorMessage(newErrorMessage);
      return; // Prevent further processing after validation fails
    }
    const currentDate = new Date().toLocaleDateString();

    const qrDataForGeneration = {
      Order_Number: JSON.stringify(formData.pur_Number) || 0,
      item_Code: formData.item_Code,
      item_Name: formData.item_Name,
      batch_Number: formData.batch_Number,
      Actual_Weight: JSON.stringify(Number(formData.Actual_Weight)),
      CreatedDate: currentDate,
    };
    setPostQr(qrDataForGeneration);
    PrintLabel(qrDataForGeneration, null, "invPosting", handleSubmit);
  };

  const hanldeScannerClick = (field) => {
    if (field === "scanner") {
      setOpenManual(false);
    } else if (field === "Manual") {
      setOpenManual(true);
    }
  };

  const handleQrScan = async (scanResult) => {
    // let data;
    // try {
    //   data =await parseFormattedQRText(scanResult);
    // } catch (err) {
    //   console.error("Invalid QR scan result:", err);
    //   return;
    // }

    // const batchNumber = data?.BatchNumber?.trim();
    const batchNumber = scanResult["batchnumber"].trim();
    if (!batchNumber) {
      toast.error(t("Batch Number not found!"));
      return;
    }
    
    const matchingBatchNumbers =
      GetDetailsItem &&
      GetDetailsItem?.filter(
        (item) => item.batch_Number?.toString().trim().toLowerCase() === batchNumber.toString().trim().toLowerCase()
      );
      
    if (matchingBatchNumbers?.length === 0) {
      toast.error(t("No matching records found."));
      return;
    }
    handleSelectSuggestion(matchingBatchNumbers[0], "batch_Number");
    setOpenManual(true);
  };

  const handleSubmit = () => {
    const {
      item_Code,
      batch_Number,
      Difference,
      Actual_Weight,
      net_Weight,
      pur_Number,
    } = formData;
    if (!item_Code || !batch_Number || !Difference || !Actual_Weight) {
      toast.error(t("Please fill in the required fields"));
      setErrorMessage({});
      return;
    }

    const weight  = parseFloat(net_Weight);
    if (Actual_Weight < weight - 60 || Actual_Weight > weight + 60) {
      toast.error(
        `Weight must be within ±60 of the tolerance value (${weight}).`
      )
      return
    }
    const currentDate = new Date().toLocaleDateString();
    const qrDataForGeneration = {
      Order_Number: JSON.stringify(formData.pur_Number) || 0,
      item_Code: formData.item_Code,
      item_Name: formData.item_Name,
      batch_Number: formData.batch_Number,
      Actual_Weight: formData.net_Weight,
      CreatedDate: currentDate,
    };
    const convertqR = generateQRData(qrDataForGeneration); 
    showSubmitConfirmation(() => {
      const currentWhsQty =
        GetWhsQty && GetWhsQty[0] ? GetWhsQty[0].uoM_Qty : 0;
      const updatedWhsQty =
        currentWhsQty && formData.Difference
          ? currentWhsQty + parseFloat(formData.Difference)
          : currentWhsQty;
          
          
      const datatoPost = {
        ipPostingDatas: [
          {
            itemCode: formData.item_Code,
            remarks: formData.Remarks ? formData.Remarks : "",
            uomQty: updatedWhsQty,
            whsCode: "RM",
            baseEntry: formData.pur_Number,
          },
        ],
        batchNumbers: [
          {
            batchNo: formData.batch_Number,
            batchQty: formData.Difference,
            absEntry: isNaN(parseInt(formData.absEntry))
              ? 0
              : parseInt(formData.absEntry),
          },
        ],
        batchData: [
          {
            batchNumber: formData.batch_Number,
            batchDetails: JSON.stringify(convertqR),
            itemName: formData.item_Name,
            itemCode: formData.item_Code,
          },
        ],
      };
      setInProgress((prev) => ({
        ...prev,
        InventoryPost: true,
      }));
      dispatch(PostInvPosting(datatoPost));
    });
  };

  const handleCloseDialog = () => {
    setOpenModel(false);
    navigate("/production/");
  };
  useEffect(() => {
    const handleBeforeUnload = (event) => {
      if (formData) {
        const message =
          "Are you sure you want to leave? Changes you made may not be saved.";
        event.returnValue = message; // Standard for most browsers
        return message; // For some older browsers
      }
    };
    window.addEventListener("beforeunload", handleBeforeUnload);
    return () => {
      window.removeEventListener("beforeunload", handleBeforeUnload);
    };
  }, [formData]);
  const handleBack = () => {
    const isFormEmpty = Object.values(formData).every((value) => !value);
    if (!isFormEmpty) {
      showNavigateConfirmation(() => {
        navigate("/production/");
      });
    } else {
      navigate("/production/");
    }
  };

  return (
    <>
      {/* <Header /> */}
      <div className="container mainDiv">
        <div className="col-12 gap-2 mb-4 d-flex align-items-center justify-content-between">
          <button onClick={handleBack} className="goBackButton gap-2 d-flex">
            <BiArrowBack size={24} />
          </button>
          <p className="m-0 fw-medium mx-3">{t("INVENTORY POSTING")}</p>
        </div>
        <div className="InventoryPosting-form">
          <InvPostingInput
            setPrintStatus={setPrintStatus}
            inputfieldLabel={inputfieldLabel}
            openManual={openManual}
            openModel={openModel}
            GetDetailsItem={GetDetailsItem}
            setFormData={setFormData}
            formData={formData}
            errorMessage={errorMessage}
            handleQrScan={handleQrScan}
            setDropdownVisible={setDropdownVisible}
            dropdownVisible={dropdownVisible}
            hanldeScannerClick={hanldeScannerClick}
            handleCloseDialog={handleCloseDialog}
            handleSelectSuggestion={handleSelectSuggestion}
          />
          {/* 
                    <QRCodeGenerator
                      QRdatas={qrData}  // Pass the QR data here
                      openQRModal={QRmodalOpen}  // Pass the modal state
                      handleCloseQRModal={handleCloseQRModal} 
                      page={'invPosting'}
                      printStatus={printStatus}
                      setPrintStatus={setPrintStatus}
                      handleSubmit={handleSubmit}
                      /> */}

          {openManual && (
            <div className="submit-button-desktop mt-3">
              <button
                onClick={onPrint}
                className="button xs w-25"
                style={{ marginRight: "18px" }}
              >
                print{" "}
              </button>
              {/* <button onClick={handleSubmit} className="button xs w-25">Submit</button> */}
            </div>
          )}
        </div>
        <Toaster
          position="top-center"
          toastOptions={{
            style: {
              fontSize: "16px",
              padding: "16px",
              width: "400px",
              borderRadius: "8px",
            },
          }}
        />
      </div>
      {isLoading() && (
        <div className="loader">
          <HashLoader color="#ed1c24" />
        </div>
      )}
      <Footer />
    </>
  );
};

export default InvPostingMain;
